import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationAddEditComponent } from './application-add-edit/application-add-edit.component';
import { ApplicationViewV1Component } from './application-view-v1/application-view-v1.component';
import { ApplicationViewComponent } from './application-view/application-view.component';
import { AuthGuard } from './common/auth-guard';
import { Route } from './common/route';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { LogoutComponent } from './logout/logout.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PaymentFailureComponent } from './payment-failure/payment-failure.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { ApplicationSearchComponent } from './application-search/application-search.component';
import { RavePaymentSuccessComponent } from './rave-payment/rave-payment.component';
import { RavePaymentFailComponent } from './rave-payment-fail/rave-payment-fail.component';
import { PaymentSuccessRaveComponent } from './payment-success-rave/payment-success-rave.component';
import { PaymentComponent } from './payment/payment.component';
import { SelectPaymentComponent } from './select-payment/select-payment.component';
import { PaymentResponseComponent } from './payment-response/payment-response.component';

const route = new Route();

const routes: Routes = [

  { path: route.HOME, component: HomeComponent, pathMatch: 'full' },

  { path: route.DASHBOARD, component: DashboardComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.APPLICATION_ADD_EDIT, component: ApplicationAddEditComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.APPLICATION_ADD_EDIT + "/:applicantId", component: ApplicationAddEditComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.APPLICATION_VIEW + "/:applicantId", component: ApplicationViewComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.APPLICATION_VIEW_V1 + "/:applicationId/:referenceId", component: ApplicationViewV1Component, pathMatch: 'full', canActivate: [AuthGuard] },

  // {path: route.APPLICATION_SEARCH, component: ApplicationSearchComponent, pathMatch: 'full'},

  // {path: route.APPLICATION_VIEW_V1 + '/:applicationId/:referenceId/:isSearchFromHome', component: ApplicationViewV1Component, pathMatch: 'full'},

  { path: route.SELECT_PAYMENT + "/:applicantId", component: SelectPaymentComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.PAYMENT_RESPONSE, component: PaymentResponseComponent, pathMatch: 'full' },

  { path: route.APPLICATION_PAYMENT + "/:applicantId/:paymentType", component: PaymentComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.PAYMENT_SUCCESS + '/:paymentData', component: PaymentSuccessComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.PAYMENT_FAILURE + "/:applicantId/:txnRefNumber", component: PaymentFailureComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.PAYMENT_RECEIPT + "/:applicantId", component: PaymentReceiptComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: route.LOGOUT, component: LogoutComponent, pathMatch: 'full' },

  { path: route.PAGE_NOT_FOUND, component: PageNotFoundComponent },

  {
    path: route.RAVE_PAYMENT_SUCCESS + '/:applicationId/:referenceNumber', component: RavePaymentSuccessComponent, pathMatch: 'full', canActivate: [AuthGuard]
  },
  {
    path: route.RAVE_PAYMENT_FAIL + '/:applicationId/:referenceNumber', component: RavePaymentFailComponent, pathMatch: 'full', canActivate: [AuthGuard]
  },

  { path: route.PAYMENT_SUCCESS_RAVE, component: PaymentSuccessRaveComponent, pathMatch: 'full' },



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
